import { CustomEventName } from '@/constants';
import { resetDataLayerAndPushEvent } from '..';

export const gtmViewAffiliateSection = () => {
  resetDataLayerAndPushEvent(CustomEventName.ViewAffiliateSection, {});
};

export interface GtmAffiliateProductClickArgs {
  productAsin: string;
  productTitle: string;
  linkUrl: string;
  productBadge?: string;
}

export const gtmAffiliateProductClick = (args: GtmAffiliateProductClickArgs) => {
  resetDataLayerAndPushEvent(CustomEventName.AffiliateProductClick, args);
};
